// WordPress's REST API returns title.rendered / content.rendered with HTML
// entities already encoded (e.g. "&" becomes "&amp;") since it's meant to be
// inserted as real HTML. When we display these as plain text in JSX (not via
// dangerouslySetInnerHTML), React never decodes them — so "&amp;" shows up
// literally on screen instead of "&". This decodes it back to plain text.
export function decodeEntities(str) {
  if (!str) return str;
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value;
}